"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cache_1 = require("./cache");
var configuration_1 = require("../configuration");
var countController_1 = require("./countController");
var DefaultPreset_1 = require("./DefaultPreset");
var TreeProvider = (function () {
    function TreeProvider(mmxl) {
        this._mmxl = mmxl;
        this._treeCache = new cache_1.Cache();
        this._rateCardCache = new cache_1.Cache();
        this._targetingKitCache = new cache_1.Cache();
    }
    TreeProvider.prototype.getTreeDataFromMmxl = function () {
        var theTreeFromCache = this._treeCache.get(configuration_1.PlanConfiguration.targetingTreeKey);
        if (theTreeFromCache !== undefined) {
            return theTreeFromCache;
        }
        if (!this._mmxl) {
            return new Promise(function (resolve, reject) { resolve(undefined); });
        }
        var result = this._mmxl.getTargetingTree(configuration_1.PlanConfiguration.targetingTreeKey);
        this._treeCache.set(configuration_1.PlanConfiguration.targetingTreeKey, result);
        return result;
    };
    TreeProvider.prototype.getTargetingTree = function () {
        return this.getTreeDataFromMmxl();
    };
    TreeProvider.prototype.getTargetingKit = function (id) {
        var targetingKitPromise = this._targetingKitCache.get(id);
        if (!targetingKitPromise) {
            targetingKitPromise = this._mmxl.getTargetingKit(id);
            this._targetingKitCache.set(id, targetingKitPromise);
        }
        return targetingKitPromise;
    };
    TreeProvider.prototype.getRateCard = function (mediumKey) {
        var rateCardPromise = this._rateCardCache.get(mediumKey);
        if (!rateCardPromise) {
            rateCardPromise = this._mmxl.getRateCard(mediumKey);
            this._rateCardCache.set(mediumKey, rateCardPromise);
        }
        return rateCardPromise;
    };
    return TreeProvider;
}());
var TreeManager = (function () {
    function TreeManager(loadDefaultTree) {
        if (loadDefaultTree === void 0) { loadDefaultTree = true; }
        var _this = this;
        if (loadDefaultTree) {
            TreeManager.getTreeManager().getTargetingTree().then(function (targetingTree) {
                _this._defaultTree = targetingTree;
            });
        }
    }
    TreeManager.getMostRecentKit = function (targetingKits) {
        return _.max(targetingKits, function (extraCharge) { return extraCharge.periodId; });
    };
    TreeManager.getTargetingCodes = function (targetingKit, adFormat) {
        if (!targetingKit.extraCharges) {
            return new Array();
        }
        return targetingKit.extraCharges
            .filter(function (extraCharge) { return extraCharge.adFormat === adFormat; })
            .map(function (extraCharge) { return extraCharge.code; });
    };
    TreeManager.getPossibleTargetings = function (targetingTree, targetingCodes) {
        return targetingTree.map(function (targetingType) {
            return _.assign({}, targetingType, { features: targetingType.features.map(function (targetingFeature) {
                    return _.assign({}, targetingFeature, { values: targetingFeature.values.filter(function (value) {
                            return targetingCodes.indexOf(value.code) !== -1;
                        })
                    });
                }).filter(function (feature) { return feature.values.length !== 0; })
            });
        }).filter(function (type) { return type.features.length !== 0; });
    };
    TreeManager.setMmxlApi = function (mmxlApi) {
        TreeManager._mmxlApi = mmxlApi;
        TreeManager._countController = new countController_1.CountController(TreeManager._analysisId, TreeManager._mmxlApi);
    };
    TreeManager.setAnalysisId = function (analysisId) {
        TreeManager._analysisId = analysisId;
        TreeManager._countController = new countController_1.CountController(TreeManager._analysisId, TreeManager._mmxlApi);
    };
    TreeManager.getTreeManager = function () {
        if (!TreeManager._treeProvider) {
            TreeManager._treeProvider = new TreeProvider(TreeManager._mmxlApi);
        }
        return TreeManager._treeProvider;
    };
    TreeManager.getCheckedItems = function (targetingTree, targetingKeys, path) {
        var result = {};
        targetingTree.forEach(function (type) {
            type.features.forEach(function (feature) {
                result[feature.caption] = new Array();
                feature.values.forEach(function (value) {
                    if (targetingKeys && targetingKeys.indexOf(value.key) !== -1) {
                        result[feature.caption].push(_.get(value, path));
                    }
                });
                if (result[feature.caption].length === 0) {
                    delete result[feature.caption];
                }
            });
        });
        return result;
    };
    TreeManager.getTargetingStatistics = function (targetingTree, targetingKeys, plan, dates) {
        var checkedItems = TreeManager.getCheckedItems(targetingTree, targetingKeys, "caption");
        var valueCounter = Object.keys(checkedItems).length;
        if (checkedItems["Bundesland"] && checkedItems["Nielsengebiet"]) {
            checkedItems["Bundesland"] = checkedItems["Bundesland"].concat(checkedItems["Nielsengebiet"]);
            delete checkedItems["Nielsengebiet"];
        }
        var featureCounter = 0;
        var resultString = "";
        var keys = Object.keys(checkedItems);
        for (var i = 0; i < keys.length; i++) {
            var properties = checkedItems[keys[i]];
            resultString += "(";
            for (var j = 0; j < properties.length; j++) {
                resultString += properties[j];
                featureCounter++;
                if (j !== properties.length - 1) {
                    resultString += " OR ";
                }
            }
            resultString += ")";
            if (i !== keys.length - 1) {
                resultString += " AND ";
            }
        }
        if (targetingKeys.length === 1) {
            resultString = resultString.substr(1, resultString.length - ")".length);
        }
        var isPresetRow = _.get(plan, "media[0].key") === "DUMMY_MEDIUM";
        var getMaxTargetingWastage = isPresetRow
            ? Promise.resolve(TreeManager._maxPossibleTargetingWastage)
            : TreeManager.getMaxWastage(targetingTree, targetingKeys, plan, dates);
        return {
            targetingString: resultString,
            values: valueCounter,
            features: featureCounter,
            getMaxTargetingWastage: getMaxTargetingWastage
        };
    };
    TreeManager.getMaxWastage = function (targetingTree, targetingKeys, plan, dates) {
        var checkedAudiences = TreeManager.getCheckedItems(targetingTree, targetingKeys, "audience");
        return TreeManager.calculateMaxWastage(checkedAudiences, plan, dates);
    };
    TreeManager.calculateMaxWastage = function (audienceObject, plan, dates) {
        var regionals = new Array();
        var others = new Array();
        for (var key in audienceObject) {
            if (audienceObject.hasOwnProperty(key)) {
                var item = audienceObject[key];
                if (key === "Bundesland" || key === "Nielsengebiet") {
                    regionals = regionals.concat(item);
                }
                else {
                    others.push(item);
                }
            }
        }
        others.push(regionals);
        var othersItems = others.map(function (item) {
            return countController_1.CountController.createOR(item);
        });
        var itemsTotal = countController_1.CountController.createAND(othersItems);
        var all = {
            "type": "A",
            "key": "FG"
        };
        var resultPromise = TreeManager._countController.sendRequest([all, itemsTotal], ["contacts"], plan, dates);
        return resultPromise.then(function (res) {
            var minArrayCount = 2;
            var result = 100;
            if (res.length >= minArrayCount) {
                var total = res[0][0].contacts;
                var part = res[1][0].contacts;
                if (total && part) {
                    result = _.round(TreeManager._maxPossibleTargetingWastage * (1 - part / total), 1);
                }
            }
            return result;
        });
    };
    TreeManager.getTargetingTreeFactory = function (mediumKey, adFormat, targetingKeys, mediumPrettyName, adformatPrettyName, wastage, informationHandler, frequencyCapping, periodPrettyName, plan, ratecardHasTargeting, dates) {
        return function _getTargetingTreeData() {
            var treeManager = TreeManager.getTreeManager();
            if (mediumKey === DefaultPreset_1.DEFAULT_PRESET.medium.key) {
                return treeManager.getTargetingTree()
                    .then(function (targetingTree) {
                    return TreeManager.compileTargetingResultData(targetingTree, targetingKeys, adFormat, mediumPrettyName, adformatPrettyName, wastage, dates, informationHandler, frequencyCapping, periodPrettyName, plan, ratecardHasTargeting);
                });
            }
            else {
                var rateCardPromise = treeManager.getRateCard(mediumKey);
                return rateCardPromise.then(function (rateCard) {
                    if (!rateCard) {
                        return;
                    }
                    return Promise.all([
                        treeManager.getTargetingKit(rateCard.targeting),
                        treeManager.getTargetingTree()
                    ]).then(function (results) {
                        var targetingKits = results[0], targetingTree = results[1];
                        var filteredTargetingTree = TreeManager.getPossibleTargetings(targetingTree, TreeManager.getTargetingCodes(TreeManager.getMostRecentKit(targetingKits), adFormat));
                        return TreeManager.compileTargetingResultData(filteredTargetingTree, targetingKeys, adFormat, mediumPrettyName, adformatPrettyName, wastage, dates, informationHandler, frequencyCapping, periodPrettyName, plan, ratecardHasTargeting);
                    });
                });
            }
        };
    };
    TreeManager.compileTargetingResultData = function (targetingTree, targetingKeys, adFormat, mediumPrettyName, adformatPrettyName, wastage, dates, informationHandler, frequencyCapping, periodPrettyName, plan, ratecardHasTargeting) {
        return {
            targetingTree: targetingTree,
            targetingKeys: targetingKeys,
            wastage: wastage,
            informationHandler: informationHandler,
            targetingStatisticsHandler: function (ttree, tkeys) {
                return TreeManager.getTargetingStatistics(ttree, tkeys, plan, dates);
            },
            frequencyCapping: frequencyCapping,
            adFormat: adFormat,
            adFormatPrettyName: adformatPrettyName,
            period: periodPrettyName,
            medium: mediumPrettyName,
            ratecardHasTargeting: ratecardHasTargeting
        };
    };
    TreeManager.prototype.getShortDescriptions = function (keys) {
        return this.getDescriptions(keys, "captionShort");
    };
    TreeManager.prototype.getLongDescriptions = function (keys) {
        return this.getDescriptions(keys, "caption", " UND ", " ODER ");
    };
    TreeManager.prototype.getDescriptions = function (keys, itemCaption, andSeparator, orSeparator) {
        if (andSeparator === void 0) { andSeparator = "&"; }
        if (orSeparator === void 0) { orSeparator = ","; }
        if (!this._defaultTree) {
            return "";
        }
        var result = TreeManager.getCheckedItems(this._defaultTree, keys, itemCaption);
        return TargetingConverter.convertToString(result, andSeparator, orSeparator);
    };
    TreeManager.getCode = function (key) {
        var startPosShift = 2;
        var targetingRegex = /(\|@)\d*(%)/g;
        var code = key.match(targetingRegex);
        var codeString = code[0].toString();
        var startPos = codeString.indexOf("|@") + startPosShift;
        var endPos = codeString.indexOf("%");
        codeString = codeString.substring(startPos, endPos);
        return codeString;
    };
    TreeManager._maxPossibleTargetingWastage = 100;
    return TreeManager;
}());
exports.TreeManager = TreeManager;
var TargetingConverter = (function () {
    function TargetingConverter() {
    }
    TargetingConverter.convertToString = function (input, andSeparator, orSeparator) {
        var keys = Object.keys(input);
        var resultObject = {};
        keys.forEach(function (key) {
            _.set(resultObject, key, "(" + input[key].join(orSeparator) + ")");
        });
        var regionalBundesland = resultObject["Bundesland"];
        var regionalNielsen = resultObject["Nielsengebiet"];
        var resultKeys = Object.keys(resultObject);
        if (regionalBundesland && regionalNielsen) {
            resultObject["regional"] = regionalBundesland + "," + regionalNielsen;
            resultKeys = _.without(resultKeys, "Bundesland", "Nielsengebiet");
            resultKeys.unshift("regional");
        }
        var result = "";
        resultKeys.forEach(function (key, index) {
            result += resultObject[key];
            if (index !== resultKeys.length - 1) {
                result += andSeparator;
            }
        });
        return result;
    };
    return TargetingConverter;
}());
//# sourceMappingURL=treeManager.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/treeManager.js
// module id = 21
// module chunks = 0